import { Value } from '@philips-internal/oswald-ui-core';

export interface RefusalConfirmationType extends Record<string, Value> {
  encounterNumber: number;
  eventDate: string;
  hourSequence?: string;
  itemCode?: string;
  itemType?: string;
  justificationDescription: string;
  prescriptionNumber?: string;
  userName?: string;
}

export interface BodyCheckInfo extends Record<string, Value>{
  itemCode: number;
  itemType: string;
  option: string;
  prescriptionNumber: string;
  procedureCode?: number;
  scheduleSequence: number;
  userName: string;
}

export enum PatientProfile {
  YES = 'S',
  MANDATORY_JUSTIFICATION = 'J',
  NO = 'N',
}

export interface ResponseShow {
  status: string;
}

export interface ProcessSequence {
  processSequence?: string;
}

export interface FirstMedicationCheckInfoResponse {
  responseDescription: string;
}

export enum Status {
  PREPARATION   = 'PREPARATION',
  ADMINISTERED  = 'ADMINISTERED',
  REFUSED_ADMINISTERED = 'REFUSED_ADMINISTERED',
  CHECKED = 'CHECKED',
  CHECKED_FIRST = 'CHECKED_FIRST'
}

export enum AdminScheduleType {
  MEDICATION = 'MEDICATION',
}
